import AgyleDialog from '../modal/agyleDialog';
import {useTranslation} from 'react-i18next';
import React, {useEffect, useState} from 'react';
import API from '../../app/api';
import AgyleLoadingSpinner from '../other/agyleLoadingSpinner';
import {useDispatch} from 'react-redux';
import {setSnackbar} from '../../store/reducers/globals';
import {AgyleTable, createAgyleTableColumn} from '../table/AgyleTable';
import {useStylesEscalationLevel} from '../../pages/admin/ward/escalationLevel';
import _ from 'lodash';

const COLUMNS = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('user', 'User', 2, 'createdByName', 'string', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('when', 'Date', 3, 'createdDate', 'date', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('wardMap', 'Ward Name', 4, 'auditData.ward', 'string', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('wardId', 'Ward Id', 5, 'auditData.wardId', 'string', 'notSort', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('level', 'Level', 6, 'auditData.level', 'escalationLevel', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('reason', 'Reason', 7, 'auditData.reason', 'string', 'notSort', 'medium', 'left', true, false, null, null, null),
];

const EscalationHistory = ({wardId, hospitalId, open, onClose}) => {
    const classes = useStylesEscalationLevel();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const controller = new AbortController();
        if (wardId && open) {
            setLoading(true);
            const options = {
                '$filter': `auditType eq 'E' and auditData.action eq 'ESCALATION_LEVEL' and auditData.wardId eq '${wardId}'`,
            };

            API.getAuditsList(options, controller.signal)
                .then(res => {
                    if (res?.data?.__data) {
                        const data = _.filter(res?.data?.__data, lev => lev?.auditData?.hospitalId === hospitalId);
                        setData(_.orderBy(data, ['createdDate'], ['desc']))
                    }
                })
                .catch(err => {
                    console.error(err);
                    dispatch(setSnackbar({type: 'error', message: t('Audit data could not be retrieved.')}));
                })
                .finally(() => {
                    setLoading(false);
                });
        }

        return () => {
            controller.abort();
        };
    }, [wardId, open]);

    return (
        <AgyleDialog
            title={t('Escalation Level History')}
            onClose={onClose}
            open={open}
            width="lg"
            fullWidth
            closeButtonOnHeader
            disableSave
        >
            <>
                {loading && <AgyleLoadingSpinner/>}
                {!loading &&
                    <AgyleTable
                        disableFilter
                        columns={COLUMNS}
                        data={data}
                        tableContainerClass={classes.table}
                        edRefresh
                    />
                }
            </>
        </AgyleDialog>
    );
};

export default EscalationHistory;